import scroll from 'scroll';
import hasDom from 'has-dom';
import scrollDoc from 'scroll-doc';
export const defaultOptions = {
  duration: 1000,
  // TODO: we could also use https://www.npmjs.com/package/ease-component
  // eslint-disable-next-line no-plusplus
  ease: n => 1 - --n * n * n * n
};

/**
 * smoothScroll
 *
 * options:
 *  - offset (Number)
 *  - duration (Number)
 *  - ease (func)
 *
 * @param anchorId (String): id of target element
 * @param options (Object)
 */
export default function smoothScroll(anchorId, options) {
  if (options === void 0) {
    options = {};
  }
  if (hasDom()) {
    const {
      offset = 0,
      onAfterScroll = () => {},
      ...rest
    } = options;
    const target = document.getElementById(anchorId);
    if (target && typeof target.getBoundingClientRect === 'function') {
      const pageYOffset = window.scrollY ? window.scrollY : window.pageYOffset;
      // getBoundingClientRect returns values based on the current Y position
      // need to add yOffset to avoid mis-calculating the target position
      const y = pageYOffset + target.getBoundingClientRect().top + offset;
      scroll.top(scrollDoc(), y, {
        ...defaultOptions,
        ...rest
      }, onAfterScroll);
    }
  }
}